import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {DownloadButtonPlaceholder} from 'src/modules/downloads/download-button-pleceholder';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {createEventCreationRoutePath} from 'src/modules/event-create/event-creation-route-planner';
import {TabId, TabItem} from 'src/modules/tabs-panel/typedefs';
import {copy} from 'src/utils/copyToClipboard';

import {Button} from '@pb/kit-component-button';
import {CheckBox} from '@pb/kit-component-checkbox';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {Tab, Tabs} from '@pb/kit-component-tabs-v2';

import {tabsPanel} from './tabs-panel.module.styl';

type Props = {
    tabs: TabItem[],
    activeTab: TabId,
    onlyMyFilter: boolean,
    showOnlyMyFilter: boolean,
    isCopyLinkDisabled: boolean,
    onChangeTab: (tab: string) => void,
    onCheckboxChange: (data: {event: React.SyntheticEvent<HTMLInputElement>}) => void,
};

export const TabsPanelView = (props: Props) => {
    const {
        tabs,
        activeTab,
        onChangeTab,
        onlyMyFilter,
        showOnlyMyFilter,
        isCopyLinkDisabled,
        onCheckboxChange,
    } = props;

    const navigate = useNavigate();

    const onClick = useCallback(() => {
        const eventCreationRoutePath = createEventCreationRoutePath({mode: EventCreationMode.create, eventId: 0});
        navigate(eventCreationRoutePath);
    }, [navigate]);

    const onLinkSharingClick = useCallback(() => {
        copy(window.location.href);
    }, []);

    return (
        <Item className={tabsPanel}>
            <Group justify="space-between">
                <Group>
                    <Tabs value={activeTab} onChange={onChangeTab}>
                        {tabs.map(tab => (
                            <Tab
                                key={tab.tabId}
                                value={tab.tabId}
                                caption={`${tab.caption} (${tab.count ?? 0})`}
                            />
                        ))}
                    </Tabs>
                    {activeTab === TabId.CHANGE_REQUESTS && (
                        <CheckBox
                            disabled={!showOnlyMyFilter}
                            checked={onlyMyFilter}
                            onCheckBoxChange={onCheckboxChange}
                            label="show only my"
                        />
                    )}
                </Group>
                <Group alignItems="center">
                    <Button
                        disabled={isCopyLinkDisabled}
                        onClick={onLinkSharingClick}
                        endIcon={<Icon type={Icons.CHAIN}/>}
                        variant="Type.SECONDARY">
                        Copy Link
                    </Button>
                    <DownloadButtonPlaceholder/>
                    <Button
                        onClick={onClick}
                        variant="Type.PRIMARY">
                        Create Event
                    </Button>
                </Group>
            </Group>
        </Item>
    );
};
